"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const expertsSlice_1 = require("../../../../../redux/slices/expertsSlice");
const auth0_id_generator_1 = __importDefault(require("auth0-id-generator"));
const expertBlocks_1 = require("./expertBlocks");
require("./editExpert.scss");
const common_1 = require("../../../../../utils/common");
const GENERATE_ID = (len, prefix) => {
    const generator = new auth0_id_generator_1.default();
    return generator.new(prefix);
};
const availableComponents = {
    "social": (key) => react_1.default.createElement(expertBlocks_1.Web, { key: key, expert: {} }),
    "education": (key) => react_1.default.createElement(expertBlocks_1.Education, { key: key, expert: 'surprise' }),
    "certs": (key) => react_1.default.createElement(expertBlocks_1.Licenses, { key: key, expert: {} }),
};
const CreateExpert = (props) => {
    const { expert } = props;
    const isCompany = common_1.urlPrams('serviceType') === 'company';
    const directoryType = parseInt(common_1.urlPrams('directoryType'));
    const action = common_1.urlPrams('action');
    react_1.useEffect(() => {
        if (!expert.uid) {
            const prefix = directoryType === 0 ? 'exp' : 'ser';
            props.editExpert({ key: "uid", val: GENERATE_ID(6, prefix) });
            props.editExpert({ key: "is_company", val: isCompany });
            props.editExpert({ key: "type", val: directoryType });
            props.editExpert({ key: "status", val: 0 });
        }
    }, []);
    return expert ? (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement("div", { className: 'paper pt-0 pb-10' },
            react_1.default.createElement("h4", null,
                action === 'create' ? 'Create' : 'Edit',
                " ",
                expert.type === 0 ? 'Expert' : isCompany ? 'Service of Expert Company' : 'Service')),
        react_1.default.createElement(expertBlocks_1.BasicInfo, null),
        react_1.default.createElement(expertBlocks_1.States, null),
        react_1.default.createElement(expertBlocks_1.ContactInfo, null),
        react_1.default.createElement(expertBlocks_1.About, null),
        directoryType === 0 && react_1.default.createElement(expertBlocks_1.Expertize, null),
        Object.values(availableComponents).map((val, key) => val(key)),
        directoryType === 1 && react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(expertBlocks_1.Services, null),
            react_1.default.createElement(expertBlocks_1.Languages, null)))) : (react_1.default.createElement(react_1.Fragment, null));
};
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        expert: experts.editableExpert || experts.expert
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        editExpert: (data) => dispatch(expertsSlice_1.editExpert(data))
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(CreateExpert);
